export const whyChooseItems = [
    {
        id: 1,
        title: "کیفیت تضمینی",
        description: "تمامی محصولات دارای گارانتی معتبر و کیفیت بین‌المللی",
        gradient: "from-[#252360] to-[#E62067]",
        icon: (
            <>
                <path d="M12 2L3 7l9 5 9-5-9-5zM3 17l9 5 9-5M3 12l9 5 9-5" />
                <path
                    d="M9 12l2 2 4-4"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                />
            </>
        ),
    },
    {
        id: 2,
        title: "پشتیبانی تخصصی",
        description: "تیم متخصص فنی آماده ارائه مشاوره و پشتیبانی ۲۴ ساعته",
        gradient: "from-[#4451A3] to-[#5168B0]",
        icon: (
            <path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z" />
        ),
    },
    {
        id: 3,
        title: "تحویل سریع",
        description: "ارسال سریع و ایمن محصولات به سراسر کشور",
        gradient: "from-[#5168B0] to-[#45C8F5]",
        icon: (
            <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z" />
        ),
    },
    {
        id: 4,
        title: "قیمت رقابتی",
        description: "بهترین قیمت بازار با کیفیت بالا و گارانتی معتبر",
        gradient: "from-[#45C8F5] to-[#E62067]",
        icon: (
            <>
                <path d="M12.79 21L3 11.21v2c0 .45.19.86.49 1.16l8.4 8.4c.3.3.71.49 1.16.49h2L12.79 21zM11.21 3L21 12.79v-2c0-.45-.19-.86-.49-1.16l-8.4-8.4C11.81 1.19 11.4 1 10.95 1h-2L11.21 3z" />
                <path d="M7.5 6.5L9 8l-1.5 1.5L6 8l1.5-1.5zm9 9L18 17l-1.5 1.5L15 17l1.5-1.5z" />
            </>
        ),
    },
];